export var SelectLayout;

(function (SelectLayout) {
  SelectLayout["Default"] = "default";
  SelectLayout["Native"] = "native";
  SelectLayout["Custom"] = "custom";
})(SelectLayout || (SelectLayout = {}));